export const WEB_INTERACTIVES_URL = '/web-interactives/v1/cos-interactives';
export const LANDING_PAGES_URL = '/cospages/v2/landing-pages';
export const WEBSITE_PAGES_URL = '/cospages/v2/site-pages';
export const PERSONALIZATION_KB = {
  BASE_URL: 'https://knowledge.hubspot.com/ai-tools/use-the-personalization-tool'
};
export const SEGMENTS_KB = {
  BASE_URL: 'https://knowledge.hubspot.com/segments/create-active-or-static-lists',
  SECTIONS: {
    types: 'https://knowledge.hubspot.com/segments/create-active-or-static-lists#types-of-segments'
  }
};